import { mdbBtn } from 'mdbvue'
export const SmallBtn = {
  name: 'SmallBtn',
  template: '<mdb-btn class="my-1 mx-1"><slot></slot></mdb-btn>',
  components: { mdbBtn }
}
